import { Factory } from 'fishery';
import { OrderJobsSearch, OrderJobsSearchResponse } from './OrderJobsService.types';

export const orderJobResponse = Factory.define<OrderJobsSearch>(({ sequence }) => ({
  classification: {
    id: '1',
    label: 'Transport',
    type: 'transport',
    isDefault: false,
  },
  guid: `1000283-${sequence}`,
  number: 'RC10001A',
  referenceNumber: null,
  type: 'transport',
  category: 'transport',
  status: 'new',
  stops: {
    pickup: 3,
    delivery: 1,
  },
  commodities: 0,
  dateCreated: '2023-01-25T20:29:52.828-08:00',
  isDummy: false,
}));

export const orderJobsSearchFactory = Factory.define<OrderJobsSearchResponse>(({ sequence }) => ({
  page: 0,
  rows: 20,
  total: 1,
  results: orderJobResponse.buildList(2),
}));
